import axios from 'axios'

const api = axios.create({
  baseURL: '/Api/', // Kembali menggunakan /Api agar proxy menangani pengalihan
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
})

export default api
